import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'
import StateStorage from 'lib/state-storage'
import ShopLanguageMap from 'lib/i18n/shop-language-map'

const shop = StateStorage.getShop()
const user = StateStorage.getAuthUser()
const id_shop = ShopLanguageMap.getIdShopBySlug(shop)
const id_customer = user?.id_customer

export const segmentPdpSeeReviewsClicked = ({ id_product }) => {
  const data = {
    id_shop,
    id_customer,
    id_product,
  }
  segmentTrackAction(EVENT.pdpSeeReviewsClicked, data)
}

export const segmentPdpSeeAllReviewsClicked = ({ id_product }) => {
  const data = {
    id_shop,
    id_customer,
    id_product,
  }
  segmentTrackAction(EVENT.pdpSeeAllReviewsClicked, data)
}

export const segmentPdpGoToOrdersClicked = ({ id_product }) => {
  const data = {
    id_shop,
    id_customer,
    id_product,
  }
  segmentTrackAction(EVENT.pdpGoToOrdersClicked, data)
}

export const segmentReviewBackToProductClicked = ({ id_product }) => {
  const data = {
    id_shop,
    id_customer,
    id_product,
  }
  segmentTrackAction(EVENT.reviewBackToProductClicked, data)
}

export const segmentReviewViewImageClicked = ({
  id_product,
  id_product_review_image,
  event,
}) => {
  const data = {
    id_shop,
    id_customer,
    id_product,
    id_product_review_image,
  }
  segmentTrackAction(event, data)
}
